
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/skeleton";
import { WeatherCarousel } from "@/components/WeatherCarousel";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

interface WeatherDialogProps {
  showWeather: boolean;
  setShowWeather: (show: boolean) => void;
  weatherData: any;
  destinationName: string;
}

export function WeatherDialog({
  showWeather,
  setShowWeather,
  weatherData,
  destinationName
}: WeatherDialogProps) {
  const { t } = useTranslation();
  const isWeatherLoading = showWeather && !weatherData;
  
  return (
    <Dialog open={showWeather} onOpenChange={setShowWeather}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            {t('weather.in')} {destinationName}
          </DialogTitle>
          <DialogDescription>
            {isWeatherLoading ? t('weather.loading') : weatherData?.headline?.Text}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-4">
          {isWeatherLoading ? (
            <div className="space-y-3">
              <Skeleton className="h-32 w-full rounded-lg" />
              <div className="flex gap-2">
                <Skeleton className="h-8 w-20 rounded" />
                <Skeleton className="h-8 w-20 rounded" />
              </div>
            </div>
          ) : (
            <>
              {weatherData?.data?.CurrentConditions && (
                <div className="mb-6 p-4 bg-travel-50 rounded-lg">
                  <div className="flex items-center justify-between">
                    <div>
                      <h3 className="text-lg font-semibold">{t('weather.currentWeather')}</h3>
                      <p className="text-sm text-muted-foreground">{weatherData.data.CurrentConditions.WeatherText}</p>
                    </div>
                    <div className="flex items-center">
                        <img 
                          src={weatherData.data.CurrentConditions.WeatherIconUrl} 
                          alt={weatherData.data.CurrentConditions.WeatherText}
                          className="w-18 h-12"
                        />
                      <span className="text-3xl font-bold ml-2">
                        {Math.round(weatherData.data.CurrentConditions.Temperature.Current.Value)}°
                        {weatherData.data.CurrentConditions.Temperature.Current.Unit}
                      </span>
                    </div>
                  </div>
                </div>
              )}
              {weatherData?.data?.DailyForecasts && <WeatherCarousel weatherData={weatherData.data.DailyForecasts} cityName={destinationName} />}
              {weatherData?.daily && <WeatherCarousel weatherData={weatherData.daily} cityName={destinationName} />}
            </>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
